module.exports = __webpack_public_path__ + "static/media/pb-j.5df9757e.jpg";